/** Normalize URL slug or CMS identifier for comparison. */
export function normalizeCmsSlug(value) {
  return String(value || "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

/** Find active CMS entry by slug (matches identifier, case/spacing insensitive). */
export function findCmsEntryBySlug(cmsList = [], slug) {
  const normalizedSlug = normalizeCmsSlug(slug);
  if (!normalizedSlug || !Array.isArray(cmsList)) return null;

  return (
    cmsList.find((entry) => {
      if (!entry || entry.status === "Deactive") return false;
      return normalizeCmsSlug(entry.identifier) === normalizedSlug;
    }) || null
  );
}

/** Whether a banner link should stay in-app (React Router) vs external. */
export function isInternalAppLink(linkUrl) {
  return (
    typeof linkUrl === "string" &&
    linkUrl.startsWith("/") &&
    !linkUrl.startsWith("//")
  );
}
